import {currentPeriod, midnight} from '@/helpers/date'
import {ONBOARDING_TOUR_FINISHED, GOALS_COLLAPSED, TASKS_LIST_FILTER, ROUTINES_LIST_FILTER, GOALS_LIST_FILTER} from './_mutations'

export default {
  appLoading: false,
  onboardingTourFinished: true,
  soundEffect: null,
  today: midnight(),
  tasksListFilter: localStorage.getItem(TASKS_LIST_FILTER),
  routinesListFilter: localStorage.getItem(ROUTINES_LIST_FILTER),
  goalsListFilter: localStorage.getItem(GOALS_LIST_FILTER),
  showSetup: false
}
